var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcSharpClear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6668 4.27331L11.7268 3.33331L8.00016 7.05998L4.2735 3.33331L3.3335 4.27331L7.06016 7.99998L3.3335 11.7266L4.2735 12.6666L8.00016 8.93998L11.7268 12.6666L12.6668 11.7266L8.94016 7.99998L12.6668 4.27331Z",
    fill: "#464E5F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSharpClear);
export default __webpack_public_path__ + "static/media/ic_sharp-clear.f8619544ccd062683c14d04e03b52f7e.svg";
export { ForwardRef as ReactComponent };